import { Popover, Sidetab } from '@typeform/embed-react'
import React from 'react'

export const TypeFormComponent = ({ isMobile, ...props }) => {
  return isMobile ? <Popover {...props} /> : <Sidetab {...props} />
}
